import {
    GET_AVAILABLE_TIMES,
    GET_SUB_ZONES,
    GET_ZONES,
    SCHEDULE_STARTS,
    SCHEDULE_STOPS,
    SCHEDULE_SUCCESS,
    START_LOADING_AVAILABLE_TIMES,
    START_LOADING_SUBZONE,
    STOP_LOADING_AVAILABLE_TIMES,
    STOP_LOADING_SUBZONE
} from "../../../services/types/SchedulerTypes";

const initialState = {

    zones: [],
    subzones: [],
    times: [],
    loadSub: false,
    loadSchedule: false,
    message: null,
    loadTime: false

};

export const SchedulerReducer=(state=initialState, action) => {

    const {type, payload} = action;
    switch (type) {

        case SCHEDULE_STOPS:
            return {

                ...state,
                loadSchedule: false

            };

        case STOP_LOADING_AVAILABLE_TIMES:
            return {

                ...state,
                loadTime: payload

            };

        case START_LOADING_AVAILABLE_TIMES:
            return {

                ...state,
                loadTime: payload

            };

        case SCHEDULE_STARTS:
            return {

                ...state,
                loadSchedule: true

            };


        case SCHEDULE_SUCCESS:
            return {

                ...state,
                message: payload,
                loadSchedule: false

            };

        case GET_ZONES:
            return {

                ...state,
                zones: payload

            };

        case GET_SUB_ZONES:
            return {

                ...state,
                subzones: payload,
                loadSub: false

            };

        case START_LOADING_SUBZONE:
            return {

                ...state,
                loadSub: payload

            };

        case STOP_LOADING_SUBZONE:
            return {

                ...state,
                loadSub: payload

            };


        case GET_AVAILABLE_TIMES:
            return {

                ...state,
                times: payload,
                loadTime: false

            };

        default:
            return state;
    }
};

export default SchedulerReducer;